function getTagPropertiesForResource(resource: string | {
  href?: string,
  src?: string
}) {
  const simpleResource = typeof resource === "string"
  const isStyle = typeof resource === "string" ? resource.endsWith(".css") :
    // Not a string... check if it's an object with a src property
    resource?.src?.endsWith(".css") ? true : false

  const tag = isStyle ? "link" : "script"
  return simpleResource ? {
    tag,
    properties: isStyle
      ? {
        rel: "stylesheet",
        //   type: "text/css",
        href: `${resource}?ts=${process.env.BUILD_TS}`,
      }
      : {
        type: "text/javascript",
        src: `${resource}?ts=${process.env.BUILD_TS}`,
      },
  } : {
    tag,
    properties: resource
   }
}

export function injectResource(resource: string | Object) {
  const { tag, properties } = getTagPropertiesForResource(resource);
  const resourceTag = document.createElement(tag);
  Object.entries(properties).forEach(([key, value]) => {
    resourceTag[key] = value;
  });
  
  document.head.appendChild(resourceTag);
}